import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import { buildFacetDesignOverride } from 'Packages/FacetRest/FacetDesignOverride';
import Layout from './Layout';

const metaOverrideSet = buildFacetDesignOverride().done();

const ActionCompletionGreatJobStepTemplate = ({ resource }) => {
  return (
    <MetaResourceRenderer
      layout={Layout}
      resource={resource}
      metaOverrideSet={metaOverrideSet}
    />
  );
};

ActionCompletionGreatJobStepTemplate.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default ActionCompletionGreatJobStepTemplate;
